import React from "react";

import "./index.scss";

type Props = {
  label: string;
  onChecked?: () => void;
  isChecked?: boolean;
};

const CustomCheckbox = (props: Props) => {
  return (
    <label id="custom-checkbox-container">
      <input type="checkbox" onChange={props.onChecked} checked={props.isChecked} />
      <p>{props.label}</p>
    </label>
  );
};

export default CustomCheckbox;
